import React from "react";

export default function ImportContactImage(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="77.787"
      height="80.768"
      viewBox="0 0 97.787 100.768"
    >
      <g id="Illustration" transform="translate(-978.5 -439.098)">
        <g id="Contacts" transform="translate(908.539 266.567)">
          <g
            id="Group_128"
            data-name="Group 128"
            transform="translate(70.461 173.307)"
          >
            <g id="Group_127" data-name="Group 127">
              <path
                id="Path_1062"
                data-name="Path 1062"
                d="M157.537,246.731a.946.946,0,0,0,1.615-.669V179.65a6.183,6.183,0,0,0-6.183-6.183H84.561a6.183,6.183,0,0,0-6.183,6.183v5.266H76.042a5.56,5.56,0,0,0-5.581,5.551,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.561,5.561,0,0,0-5.581,5.552,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.56,5.56,0,0,0-5.581,5.551,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.561,5.561,0,0,0-5.581,5.552,5.464,5.464,0,0,0,5.457,5.364h2.459v6.463a6.183,6.183,0,0,0,6.183,6.183h68.408a6.183,6.183,0,0,0,6.183-6.183V241.344"
                transform="translate(-70.461 -173.467)"
                fill="#fff"
              />
              <path
                id="Path_10135"
                data-name="Path 10135"
                d="M9.777,3.619V12.6h6.1v7.366h-6.1v12l6.1.674v6.225h-6.1V51.082h6.1v7.53h-6.1V70.066h6.1v7.655h-6.1V87.905l2.606,2.776H25.909V1.675H12.384Z"
                fill="#fee0c0"
              />
              <path
                id="Path_10136"
                data-name="Path 10136"
                d="M40.453,57.641l2.912-7.624L51,45.88l-1.68-7.031,2.79-5.2h6.153l5,5.2L61.461,45.88l4.727,2.066,5.559,6.33v3.364l-14.6,2.08Z"
                fill="#fee0c0"
              />
            </g>
          </g>
          <g
            id="Group_130"
            data-name="Group 130"
            transform="translate(70.461 173.031)"
          >
            <g id="Group_129" data-name="Group 129">
              <path
                id="Path_1064"
                data-name="Path 1064"
                d="M167.042,211.969a6.1,6.1,0,0,0-6.095-6.095H138.1A6.1,6.1,0,0,0,132,211.969v11.044a1.616,1.616,0,1,0,3.231,0V211.969a2.866,2.866,0,0,1,2.863-2.863h22.851a2.866,2.866,0,0,1,2.863,2.863V235.7a18.244,18.244,0,0,0-7.276-5.448,8.75,8.75,0,1,0-14.026,0,18.244,18.244,0,0,0-7.276,5.448V220.929a1.615,1.615,0,1,0-3.231,0V240.3A6.1,6.1,0,0,0,138.1,246.4h22.851a6.1,6.1,0,0,0,6.095-6.095V211.969Zm-17.52,7.535A5.519,5.519,0,1,1,144,225.022,5.525,5.525,0,0,1,149.522,219.5Zm11.425,23.663H138.1a2.863,2.863,0,0,1-2.579-1.627,15.05,15.05,0,0,1,9.792-8.851,8.729,8.729,0,0,0,8.424,0,15.048,15.048,0,0,1,9.792,8.851A2.863,2.863,0,0,1,160.947,243.166Z"
                transform="translate(-93.054 -185.088)"
                fill="#fb972e"
                stroke="#fb972e"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <path
                id="Path_1065"
                data-name="Path 1065"
                d="M78.378,259.194a6.183,6.183,0,0,0,6.183,6.183h68.408a6.183,6.183,0,0,0,6.183-6.183V240.908c-1.426-1.621-3.231-.633-3.231.777v17.509a2.953,2.953,0,0,1-2.952,2.952H98.078V176.262h54.891a2.952,2.952,0,0,1,2.952,2.952v65.464a1.616,1.616,0,0,0,1.616,1.616h0a.946.946,0,0,0,1.615-.669V179.214a6.183,6.183,0,0,0-6.183-6.183H84.561a6.183,6.183,0,0,0-6.183,6.183v5.266H76.042a5.559,5.559,0,0,0-5.581,5.551,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.56,5.56,0,0,0-5.581,5.551,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.561,5.561,0,0,0-5.581,5.552,5.464,5.464,0,0,0,5.457,5.364h2.459v8.2H76.043a5.56,5.56,0,0,0-5.581,5.551,5.464,5.464,0,0,0,5.457,5.364h2.459Zm-2.459-67.03a2.226,2.226,0,0,1,0-4.452h8.15a2.226,2.226,0,1,1,0,4.452Zm0,19.112a2.226,2.226,0,0,1,0-4.453h8.15a2.226,2.226,0,1,1,0,4.453Zm0,19.112a2.226,2.226,0,0,1,0-4.453h8.15a2.226,2.226,0,0,1,0,4.453Zm0,19.112a2.226,2.226,0,0,1,0-4.452h8.15a2.226,2.226,0,1,1,0,4.452Zm5.691,3.231h2.459a5.458,5.458,0,0,0,0-10.915H81.609v-8.2h2.459a5.458,5.458,0,0,0,0-10.916H81.609v-8.2h2.459a5.458,5.458,0,0,0,0-10.915H81.609v-8.2h2.459a5.458,5.458,0,0,0,0-10.915H81.609v-5.267a2.955,2.955,0,0,1,2.952-2.952H94.847v85.884H84.561a2.955,2.955,0,0,1-2.952-2.952Z"
                transform="translate(-70.461 -173.031)"
                fill="#fb972e"
                stroke="#fb972e"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <rect
                id="Rectangle_1784"
                data-name="Rectangle 1784"
                width="28"
                height="27"
                transform="translate(69 71.345)"
                fill="#fff"
              />
              <path
                id="Path_1063"
                data-name="Path 1063"
                d="M165.427,281.023H133.618a1.616,1.616,0,0,0,0,3.231h31.809a1.616,1.616,0,0,0,0-3.231Z"
                transform="translate(-93.054 -212.678)"
                fill="#fb972e"
                stroke="#fb972e"
                stroke-miterlimit="10"
                stroke-width="1"
              />
            </g>
          </g>
        </g>
        <g id="Import" transform="translate(868.533 232.805)">
          <path
            id="Union_21"
            data-name="Union 21"
            d="M4.235,24A4.243,4.243,0,0,1,0,19.762V18.54a1.413,1.413,0,1,1,2.826,0v1.222a1.411,1.411,0,0,0,1.409,1.411H19.765a1.41,1.41,0,0,0,1.412-1.411V4.232A1.412,1.412,0,0,0,19.765,2.82H4.235A1.412,1.412,0,0,0,2.826,4.232V5.457A1.413,1.413,0,1,1,0,5.457V4.232A4.242,4.242,0,0,1,4.235,0H19.765A4.238,4.238,0,0,1,24,4.232V19.762A4.239,4.239,0,0,1,19.765,24Zm8.271-10.046.432-.413H2.125a1.414,1.414,0,1,1,0-2.824H12.937l-.432-.417c-.579-.551-1.38-1.442-.8-1.994a1.526,1.526,0,0,1,2.09,0c3.145,3.01,3.309,3.01,3.379,3.682a1.36,1.36,0,0,1-.327,1.033c-.07.079.164-.146-3.052,2.928a1.493,1.493,0,0,1-1.046.413C11.443,16.36,11.57,14.845,12.505,13.952Z"
            transform="translate(183.504 282.814)"
            fill="#fb972e"
            stroke="#fb972e"
            stroke-miterlimit="10"
            stroke-width="0.5"
          />
        </g>
      </g>
    </svg>
  );
}
